import React, { useState, useEffect } from 'react';
import { 
    Box, Typography, Grid, FormControl, InputLabel, Select, MenuItem, Modal, Autocomplete,  Table, TableBody, TableCell, TableContainer, TableRow, Paper, 
    TableHead, Button, TablePagination, TextField, Dialog, 
    DialogActions, DialogContent, DialogContentText, DialogTitle 
} from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend, Cell, ResponsiveContainer } from 'recharts';
// import AddEstadoTarea from './AddEstadoTarea';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ListaOrdenes from './ListaOrdenes';

function GestionEncuestaDashboard() {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [totalEncuestas, setTotalEncuestas] = useState(0);
    const [totalFiltrado, setTotalFiltrado] = useState(0);
    const [rango, setRango] = useState('semana');
    const [fecha, setFecha] = useState('');
    const [mes, setMes] = useState('');
    const [anio, setAnio] = useState('');
    const [semana, setSemana] = useState('');
    const [datosGraficas, setDatosGraficas] =  useState([]);
    const [encuestas, setEncuestas] = useState([]);
    const [encuestaSeleccionada, setEncuestaSeleccionada] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [tituloModal, setTituloModal] = useState('')
    const [mostrarDetalles, setMostrarDetalles] = useState(null);
    const [detalleSeleccionado, setDetalleSeleccionado] = useState([]);
    // const [seccionExpandida, setSeccionExpandida] = useState(null);

    const [fechaDesde, setFechaDesde] = useState('');
    const [fechaHasta, setFechaHasta] = useState('');
    const aniosDisponibles = Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i);
    const [opiniones, setOpiniones] = useState([]);
    const [totalOpiniones, setTotalOpiniones] = useState(0);
    const [paginaOpiniones, setPaginaOpiniones] = useState(1);

    const filasPorPagina = 25;

    const meses = [
  { value: 1, label: "Enero" },
  { value: 2, label: "Febrero" },
  { value: 3, label: "Marzo" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Mayo" },
  { value: 6, label: "Junio" },
  { value: 7, label: "Julio" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Septiembre" },
  { value: 10, label: "Octubre" },
  { value: 11, label: "Noviembre" },
  { value: 12, label: "Diciembre" },
];

const semanas = [1, 2, 3, 4, 5]; // Si manejas semanas reales (semana del mes)

   useEffect(() => {
        const fetchEncuestas = async () => {
            try {
                const response = await fetch(`${server}/CrmEncuestums`);
                if (!response.ok) throw new Error(`Error ${response.status}`);
                const data =  await response.json();
                console.log('data encuestas:', data);

                 const arr = Array.isArray(data.$values)
                  ? data.$values
                  : Array.isArray(data)
                    ? data
                    : [];

                setEncuestas(arr);
                // setEncuestas(data);
            } catch (error) {
                console.error('Error al cargar total de encuestas:', error);
            }
        };

        fetchEncuestas();
    }, []);

    useEffect(() => {
        const fetchTotalEncuestas = async () => {
            try {
              
              const params = new URLSearchParams();
              if (encuestaSeleccionada) params.append('idEncuesta', encuestaSeleccionada);
              if (fechaDesde) params.append('fechaDesde', fechaDesde);
              if (fechaHasta) params.append('fechaHasta', fechaHasta);

              const queryStr = params.toString();
              let url = `${server}/CrmEncuestaEnviadums/total-contestadas${queryStr ? `?${queryStr }` : ''}`;
                
              // if (encuestaSeleccionada) {
              //   url += `?idEncuesta=${encuestaSeleccionada}`;
              // }

              const response = await fetch(url);
                const data =  await response.json();
                setTotalEncuestas(data.total);
            } catch (error) {
                console.error('Error al cargar total de encuestas:', error);
            }
        };

        fetchTotalEncuestas();
    }, [encuestaSeleccionada, fechaDesde, fechaHasta]);


    const limpiarDatos = (obj) => {
        if (Array.isArray(obj)) {
          return obj.map(limpiarDatos);
        } else if (obj !== null && obj.constructor === Object) {
          return Object.entries(obj).reduce((acumulador, [clave, valor]) => {
            if (!clave.startsWith('$')) {
              acumulador[clave] = limpiarDatos(valor);
            }
            return acumulador;
          }, {});
        }
        return obj;
      };

    useEffect(() => {
      if (!encuestaSeleccionada) return;

      const fetchGraficas = async () =>{
        try {

          const params = new URLSearchParams({ idEncuesta: encuestaSeleccionada});

          if (fechaDesde) params.append('fechaDesde', fechaDesde);
          if (fechaHasta) params.append('fechaHasta', fechaHasta);
          let url = `${server}/CrmRespuestaEncuestums/resultados?${params.toString()}`;
          // const res = await fetch(`${server}/CrmRespuestaEncuestums/resultados?idEncuesta=${encuestaSeleccionada}`);
          // console.log('encuestaSeleccionada usada en fetch:', encuestaSeleccionada);
          // console.log('URL fetch:', `${server}/CrmRespuestaEncuestums/resultados?idEncuesta=${encuestaSeleccionada}`)

          // if (fechaDesde){
          //   url +=`&fechaDesde=${fechaDesde}`;
          // }

          // if(fechaHasta){
          //   url += fechaDesde
          //     ? `&fechaHasta=${fechaHasta}`
          //     : `?fechaHasta=${fechaHasta}`;
          // }

          const res = await fetch(url);
          console.log("URL FINAL:", url);

          if (!res.ok) throw new Error(`Error ${res.status}`);
          const data = await res.json();
          console.log('api dashboard-resultados:', data);
          const datos = Array.isArray(data.$values) ? data.$values : Array.isArray(data) ? data : [];
          
        const datosLimpios = datos.map((item) => {
        // pregunta: item.pregunta,
         const respuestas = item.respuestas || {};

          const respuestasLimpias = Object.entries(respuestas)
          .filter(([key]) => !key.startsWith('$'))
          .map(([opcion, valor]) => {
            const total = typeof valor.total === 'number'
              ? valor.total
              : parseInt(valor.total) || 0;

            const detalles = Array.isArray(valor.detalles)
              ? valor.detalles
              : valor.detalles && Array.isArray(valor.detalles.$values)
              ? valor.detalles.$values
              : [];

            return [opcion, { total, detalles }];
          });

         return {
          pregunta: item.pregunta,
          // respuestas: respuestasLimpias
          respuestas: Object.fromEntries(respuestasLimpias),
         };
      });

        setDatosGraficas(datosLimpios);
        console.log('Datos mapeados para gráficas:', datosLimpios);
        } catch (error) {
          console.error('Error al cargar resultados:', error);
        }
      };
      fetchGraficas();
    }, [encuestaSeleccionada, fechaDesde, fechaHasta]);

    useEffect(() => {

  if (!encuestaSeleccionada) return;

    const fetchOpiniones = async () => {
      try {

        const params = new URLSearchParams({
          idEncuesta: encuestaSeleccionada,
          pagina: paginaOpiniones,
          pageSize: filasPorPagina
        });

        if (fechaDesde) {
          params.append("fechaDesde", fechaDesde);
        }

        if (fechaHasta) {
          params.append("fechaHasta", fechaHasta);
        }

        const response = await fetch(
          `${server}/CrmRespuestaEncuestums/opiniones?${params.toString()}`
        );

        if (!response.ok) {
          throw new Error(`Error ${response.status}`);
        }

        const data = await response.json();

        console.log("RESPUESTA API:", data);
        console.log("TOTAL:", data.total);
        console.log("PAGINA:", data.pagina);
        console.log("PAGE SIZE:", data.pageSize);

        console.table(
          (data.opiniones?.$values || data.opiniones || []).map(x => ({
            idRespuesta: x.idRespuesta,
            idOrden: x.idOrden,
            fechaIngreso: x.fechaIngreso
          }))
        );

        const opinionesArray = Array.isArray(data.opiniones?.$values)
          ? data.opiniones.$values
          : Array.isArray(data.opiniones)
            ? data.opiniones
            : [];

        setOpiniones(opinionesArray);
        setTotalOpiniones(data.total || 0);


      } catch (error) {
        console.error("Error cargando opiniones:", error);
      }
    };

    fetchOpiniones();

  }, [
    encuestaSeleccionada,
    fechaDesde,
    fechaHasta,
    paginaOpiniones
  ]);

  useEffect(() => {
    setPaginaOpiniones(1);
  }, [
    encuestaSeleccionada,
    fechaDesde,
    fechaHasta
  ]);

    useEffect(() => {
        const fetchTotalFiltrado = async () => {
            try {
                let url = `${server}/CrmEncuestaEnviadums/total-encuestas-contestadas?rango=${rango}`;
                  if (encuestaSeleccionada) {
                    url += `&idEncuesta=${encuestaSeleccionada}`;
                  }

                 if (rango === 'dia' && fecha) {
                  url += `&fecha=${fecha}`;
                }

                if (rango === 'mes-anio' && mes && anio) {
                  url += `&mes=${mes}&anio=${anio}`;
                }

                if (rango === 'semana-mes' && mes && semana) {
                  url += `&mes=${mes}&semana=${semana}`;
                }

                if (rango === 'anio' && anio) {
                  url += `&anio=${anio}`;
                }

                if ((rango === 'semana' || rango === 'mes') && fecha) {
                  url += `&fecha=${fecha}`;
                }

                console.log("🟡 URL construida:", url);

                const response = await fetch(url);
                const data = await response.json();
                setTotalFiltrado(data.total);
              } catch (error) {
                console.error('Error al cargar total filtrado:', error);
              }
            };

            if (
              (rango === 'dia' && fecha) ||
              (rango === 'mes-anio' && mes && anio) ||
              (rango === 'semana-mes' && mes && semana) ||
              ((rango === 'semana' || rango === 'mes') && fecha) ||
              (rango === 'anio' && anio)
            ) {
              fetchTotalFiltrado();
            }
          }, [rango, fecha, mes, anio, semana, encuestaSeleccionada]);

    const handleChange = (e) => {
  setEncuestaSeleccionada(e.target.value);
  console.log('Seleccionaste encuesta:', e.target.value);
}

const handleVerDetalles = (detalles, pregunta, opcion) => {
  setMostrarDetalles({ detalles, pregunta, opcion });
};

const handleAbrirModal = (orden) => {
  setDetalleSeleccionado([orden]);
  setTituloModal(`Orden: ${orden.idOrden}`);
  setModalOpen(true);
};

const opinionesAgrupadas = opiniones.reduce((acc, item) => {
  const orden = item.idOrden || "";

  if (!acc[orden]) {
    acc[orden] = [];
  }

  acc[orden].push(item);

  return acc;
}, {});


return (
<>

 <Box 
  className="right_col" 
  role="main"
  sx={{
    height: '100vh',
    overflow: 'auto',
    px: {xs: 2, sm: 3, md: 6},
    pt: 2,
    boxSizing: 'border-box',
  }}
  style={{background: 'white'}}

  >


     <div className="ln_solid" />

    <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2' }}>
      📊 Dashboard de Encuestas
    </Typography>
   <Box >
        <Grid container spacing={4}>
          
               <Grid item xs={12} md={4} >
                <Paper
                    elevation={3}
                    sx={{
                    backgroundColor: '#e3f2fd',
                    color: '#0d47a1',
                    padding: 2,
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',
                    borderLeft: '6px solid #1976d2'
                    }}
                >
                    <InsertChartIcon sx={{ fontSize: 40, marginRight: 2 }} />
                    <Box>
                    <Typography variant="h5">{totalEncuestas}</Typography>
                    <Typography variant="subtitle1">Encuestas Contestadas</Typography>
                    </Box>
                </Paper>
                </Grid>

          </Grid>
        {/* Espaciado entre secciones */}
            <Box sx={{ mt: 5 }} />
            
         <Grid container spacing={4}>
          {/* Selector de rango */}
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel id="rango-label">Rango de tiempo</InputLabel>
              <Select
                labelId="rango-label"
                value={rango}
                label="Rango de tiempo"
                onChange={(e) => {
                    const valor = e.target.value;
                    setRango(valor);
                    setFecha('');
                    setMes('');
                    setAnio('');
                    setSemana('');
                //  if (e.target.value !== 'dia') {
                    setFecha(''); // limpiar 
                    //fecha si no es "día"
                  // }
                }}
              >
                <MenuItem value="dia">Día</MenuItem>
                <MenuItem value="anio">Año</MenuItem>
                <MenuItem value="mes-anio">Mes + Año</MenuItem>
                <MenuItem value="semana-mes">Semana + Mes</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Campos condicionales */}
          {rango === 'dia' && (
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                type="date"
                label="Selecciona una fecha"
                InputLabelProps={{ shrink: true }}
                value={fecha}
                onChange={(e) => setFecha(e.target.value)}
              />
            </Grid>
          )}

        

        {/* Campos para mes-anio */}
        {rango === "mes-anio" && (
          <>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel id="mes-label">Mes</InputLabel>
                <Select
                  labelId="mes-label"
                  value={mes}
                  label="Mes"
                  onChange={(e) => setMes(e.target.value)}
                >
                  {meses.map((m) => (
                    <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel id="anio-label">Año</InputLabel>
                <Select
                  labelId="anio-label"
                  value={anio}
                  label="Año"
                  onChange={(e) => setAnio(e.target.value)}
                >
                  {aniosDisponibles.map((a) => (
                    <MenuItem key={a} value={a}>{a}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </>
        )}
        {rango === "semana-mes" && (
          <>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                type="month"
                label="Mes (YYYY-MM)"
                InputLabelProps={{ shrink: true }}
                value={mes}
                onChange={(e) => setMes(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel id="semana-label">Semana</InputLabel>
                <Select
                  labelId="semana-label"
                  value={semana}
                  label="Semana"
                  onChange={(e) => setSemana(e.target.value)}
                >
                  {[1, 2, 3, 4, 5].map((num) => (
                    <MenuItem key={num} value={num}>
                      {num}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </>
        )}

          {rango === "anio" && (
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel id="anio-label">Año</InputLabel>
              <Select
                labelId="anio-label"
                value={anio}
                label="Año"
                onChange={(e) => setAnio(e.target.value)}
              >
                {aniosDisponibles.map((a) => (
                  <MenuItem key={a} value={a}>{a}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
             {/* Tarjeta: Total filtrado */}
          <Grid item xs={10} md={4}>
            <Paper
              elevation={3}
              sx={{
                backgroundColor: '#fffde7',
                color: '#795548',
                padding: 2,
                display: 'flex',
                alignItems: 'center',
                height: '100%',
                borderLeft: '6px solid #fbc02d'
              }}
            >
              <FilterAltIcon sx={{ fontSize: 40, marginRight: 2}} />
              <Box>
                <Typography variant="h5">{totalFiltrado}</Typography>
                <Typography variant="subtitle1">
                  Encuestas ({rango.charAt(0).toUpperCase() + rango.slice(1)})
                </Typography>
              </Box>
            </Paper>
          </Grid>

          {/* Espaciado entre secciones */}
            <Box sx={{ mt: 5 }} />


            {/*Selector de encuesta*/}
        <Grid  container spacing={4} sx={{ px: { xs: 4, sm: 3, md: 6 } }}>
          <Grid  item xs={12} sx={{ mt: 4 }}>
            <FormControl fullWidth sx={{ mt: 4 }}>
              <Autocomplete
                options={encuestas}
                getOptionLabel={(option) => option.titulo}
                value={encuestas.find(e => e.idEncuesta === encuestaSeleccionada) || null}
                onChange={(e, value) => setEncuestaSeleccionada(value?.idEncuesta || '')}
                
                renderOption={(props, option) => (
                  <li
                    {...props}
                    style={{
                      backgroundColor: option.activa ? "#e8f5e9" : "white", // verde suave
                      borderLeft: option.activa ? "4px solid #4caf50" : "4px solid transparent",
                      padding: "8px"
                    }}
                  >
                    {option.titulo}
                    {option.activa && (
                      <span style={{ marginLeft: 8, color: "#2e7d32", fontSize: 12 }}>
                        (Activa)
                      </span>
                    )}
                  </li>
                )}

                renderInput={(params) => (<TextField {...params} label="Buscar encuesta" variant="outlined" />)}
              >
              </Autocomplete>
            </FormControl>
          </Grid>
        </Grid>

       <Grid  container spacing={4}  sx={{
          px: { xs: 4, sm: 3, md: 6 },
          mt: 2,
          mb: 2
        }}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              type="date"
              label="Fecha Desde"
              InputLabelProps={{ shrink: true }}
              value={fechaDesde}
              onChange={(e) => setFechaDesde(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              type="date"
              label="Fecha Hasta"
              InputLabelProps={{ shrink: true }}
              value={fechaHasta}
              onChange={(e) => setFechaHasta(e.target.value)}
            />
          </Grid>
        </Grid>
        
          {/* Sección de gráficos por pregunta */}
          <Box sx={{ mt: 5, maxWidth: 1200, mx: 'auto', marginBottom: '60px'}}>
            <Typography variant="h5" sx={{ mb: 3 }}>Resultados por Pregunta</Typography>
            {/* {Array.isArray(datosGraficas) && datosGraficas.length > 0 ? ( */}
            {datosGraficas.length > 0 ? (
            <Grid container spacing={4}>
                {datosGraficas.map((item, index) => {
                const data = Object.entries(item.respuestas).map(([opcion, info]) => ({
                  opcion,
                  total: typeof info.total === 'number' ? info.total : 0
                }));
                const esEscala = data.every(d => ['1', '2', '3', '4', '5'].includes(d.opcion));
                return (
                  // <Grid item xs={12} key={index}>
                  //   <Paper elevation={2} sx={{ p: 2 }}>
                  //     <Typography variant="subtitle1" gutterBottom>{item.pregunta}</Typography>

                  //     {/* Gráfico de barras */}
                  //     <ResponsiveContainer width="100%" height={250}>
                  //       <BarChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 5}}>
                  //         <CartesianGrid strokeDasharray="3 3"/>
                  //         <XAxis dataKey="opcion" />
                  //         <YAxis allowDecimals={false} />
                  //         <Tooltip />
                  //         <Legend />
                  //         <Bar
                  //           dataKey="total"
                  //           fill="#1976d2"
                  //           onClick={(data, index) => {
                  //             console.log('Clicked on bar:', data);
                  //             const opcionSeleccionada = data.opcion;
                  //             const infoRespuesta = item.respuestas[opcionSeleccionada];

                  //             if (infoRespuesta?.detalles?.length > 0) {
                  //               handleVerDetalles(infoRespuesta.detalles, item.pregunta, opcionSeleccionada);
                  //             }
                  //           }}
                  //         />
                  //         </BarChart>
                  //     </ResponsiveContainer>
                    <Grid item xs={12} key={index}>
                    <Paper
                      elevation={3}
                      sx={{
                        p: 3,
                        backgroundColor: '#fefefe',
                        borderRadius: 3,
                        border: '1px solid #e0e0e0',
                        
                      }}
                    >
                      <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                        {item.pregunta}
                      </Typography>

                      {esEscala ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 6, mt: 2 }}>
                          
                          {data.map((d, i) => (
                            <Box
                              key={i}
                              onClick={() => {
                                const infoRespuesta = item.respuestas[d.opcion];
                                if (infoRespuesta?.detalles?.length > 0) {
                                  handleVerDetalles(infoRespuesta.detalles, item.pregunta, d.opcion);
                                }
                              }}
                              sx={{
                                cursor: 'pointer',
                                textAlign: 'center',
                                '&:hover': {
                                  backgroundColor: '#fffde7',
                                  borderRadius: 2,
                                },
                                p: 1
                              }}
                            >
                              <Box sx={{ fontSize: '2rem', lineHeight: 1 }}>
                                {Array.from({ length: 5 }, (_, starIdx) => (
                                  <span 
                                    key={starIdx}
                                      style={{
                                      fontSize: '2rem',
                                      color: starIdx < parseInt(d.opcion) ? '#FFD700' : '#E0E0E0',
                                      border: 'none',
                                      outline: 'none',
                                      textShadow: 'none',
                                    }}
                                    >
                                    {starIdx < parseInt(d.opcion) ? '⭐️' : '☆'}
                                  </span>
                                ))}
                              </Box>
                              <Typography variant="body2" sx={{ mt: 1 }}>
                                {d.total} votos
                              </Typography>
                            </Box>
                          ))}
                        </Box>
                      ) : (

                      <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 40 }}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis
                            dataKey="opcion"
                            angle={-20}
                            textAnchor="end"
                            interval={0}
                            height={60}
                          />
                          <YAxis allowDecimals={false} />
                          <Tooltip
                            content={({ active, payload }) => {
                              if (active && payload && payload.length) {
                                return (
                                  <Paper sx={{ p: 1 }}>
                                    <Typography variant="body2">
                                      {payload[0].payload.opcion}: <strong>{payload[0].value}</strong>
                                    </Typography>
                                  </Paper>
                                );
                              }
                              return null;
                            }}
                          />
                          <Bar dataKey="total" isAnimationActive animationDuration={800}>
                            {data.map((entry, idx) => (
                              <Cell
                                key={`cell-${idx}`}
                                fill={
                                  ['#1976d2', '#0288d1', '#26c6da', '#80deea', '#b3e5fc'][
                                    idx % 5
                                  ]
                                }
                                cursor="pointer"
                                onClick={() => {
                                  const opcionSeleccionada = entry.opcion;
                                  const infoRespuesta = item.respuestas[opcionSeleccionada];
                                  if (infoRespuesta?.detalles?.length > 0) {
                                    handleVerDetalles(infoRespuesta.detalles, item.pregunta, opcionSeleccionada);
                                  }
                                }}
                              />
                            ))}
                          </Bar>
                        </BarChart>
                      </ResponsiveContainer>
                      )}
                      {mostrarDetalles?.pregunta === item.pregunta && (
                      <Box
                        sx={{
                          maxHeight: 300,
                          overflowY: 'auto',
                          mt: 3,
                          border: '1px solid #ccc',
                          borderRadius: 2,
                          p: 2,
                          backgroundColor: '#f9f9f9',
                        }}
                      >
                        <Typography variant="subtitle2" sx={{ mb: 2 }}>
                          Detalles de: <strong>{mostrarDetalles.opcion}</strong>
                        </Typography>
                        
                        {/* {console.log("Detalles pasados a ListaOrdenes:", mostrarDetalles.detalles)} */}
                        <ListaOrdenes 
                          ordenes={mostrarDetalles.detalles}
                          fechaDesde={fechaDesde}
                          fechaHasta={fechaHasta} />
                         </Box>
                        )}
                    </Paper>
                  </Grid>
                );
              })}
            </Grid>
            ) : (
              encuestaSeleccionada && <Typography>No hay datos disponibles para esta encuesta.</Typography>
              
            )}
          </Box>


           </Grid>
        </Box>
        <Box
              sx={{
                mt: 6,
                mb: 8
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  mb: 3,
                  fontWeight: "bold"
                }}
              >
                Opiniones de Clientes
              </Typography>

              <Paper elevation={3}>
                <TableContainer>

                  <Table>

                    <TableHead>
                      <TableRow>
                        <TableCell>
                          Fecha
                        </TableCell>

                        <TableCell>
                          Orden
                        </TableCell>

                        <TableCell>
                          Pregunta
                        </TableCell>

                        <TableCell>
                          Comentario
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>

                        {Object.keys(opinionesAgrupadas).length > 0 ? (

                          Object.entries(opinionesAgrupadas).map(
                            ([idOrden, respuestas]) => (
                              <React.Fragment key={idOrden}>

                                {/* CABECERA DE ORDEN */}
                                <TableRow
                                  sx={{
                                    backgroundColor: "#e3f2fd"
                                  }}
                                >
                                  <TableCell
                                    colSpan={4}
                                    sx={{
                                      fontWeight: "bold",
                                      fontSize: "1rem"
                                    }}
                                  >
                                    Orden {idOrden + ' '} 
                                    {/* Orden #{respuestas[0]?.abreviatura}{respuestas[0]?.idOrdenMes} */}
                                     {respuestas[0]?.idOrdenMes
                                        ? `/ #${respuestas[0]?.abreviatura ?? ''}${respuestas[0]?.idOrdenMes}`
                                        : 'Encuesta Anónima'}
                                  </TableCell>
                                </TableRow>

                                {/* RESPUESTAS DE ESA ORDEN */}
                                {respuestas.map((item) => (
                                  <TableRow
                                    key={item.idRespuesta}
                                    hover
                                  >
                                    <TableCell>
                                      {item.fechaIngreso
                                        ? new Date(
                                            item.fechaIngreso
                                          ).toLocaleDateString()
                                        : "-"}
                                    </TableCell>

                                    <TableCell>
                                      {item.idOrden}
                                    </TableCell>

                                    <TableCell>
                                      {item.pregunta}
                                    </TableCell>

                                    <TableCell
                                      sx={{
                                        maxWidth: 500,
                                        whiteSpace: "normal"
                                      }}
                                    >
                                      {item.comentario}
                                    </TableCell>
                                  </TableRow>
                                ))}

                              </React.Fragment>
                            )
                          )

                        ) : (
                        <TableRow>
                          <TableCell
                            colSpan={4}
                            align="center"
                          >
                            No hay opiniones para mostrar
                          </TableCell>
                        </TableRow>

                      )}

                    </TableBody>

                  </Table>

                </TableContainer>

                <TablePagination
                  component="div"
                  count={totalOpiniones}
                  page={paginaOpiniones - 1}
                  rowsPerPage={filasPorPagina}
                  rowsPerPageOptions={[10,25,50]}
                  onPageChange={(event, newPage) => {
                    setPaginaOpiniones(newPage + 1);
                  }}
                />

              </Paper>
            </Box>   
              </Box> 

           

        {/* </div> */}

       
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          border: '2px solid #1976d2',
          boxShadow: 24,
          p: 4,
          maxHeight: 500,
          overflowY: 'auto',
        }}>
          <Typography variant="h6" gutterBottom>{tituloModal}</Typography>
          <ul>
            {detalleSeleccionado.map((det, idx) => (
              <li key={idx}>
                {det.idOrden ? `Orden: ${det.idOrden}` : 'Encuesta Anónima'}
              </li>
            ))}
          </ul>
        </Box>
      </Modal>




 
    </>



     
    );
}

export default GestionEncuestaDashboard;